// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorMessage_error__C4MEw","customWarning":"ErrorMessage_customWarning__7mMSx","infoMessage":"ErrorMessage_infoMessage__3U0J7"};